import MainView from 'js/views/main';
import initClipboardCopier from 'pmn/utils/clipboardCopier';
import { initShareButtons } from 'js/utils/share-buttons';

export default class View extends MainView {
  mount() {
    super.mount();

    initClipboardCopier('share-by-url-select', 'share-by-url-copy');

    this.copyTextfieldClicked = false;
    document.getElementById('share-by-url-select').onclick = () => {
      if (this.copyTextfieldClicked) {
        return;
      }
      this.track('Clicked to share by copy', { position: 'textbox' });
      this.copyTextfieldClicked = true;
    };

    this.copyButtonClicked = false;
    document.getElementById('share-by-url-copy').onclick = () => {
      if (this.copyButtonClicked) {
        return;
      }
      this.track('Clicked to share by copy', { position: 'button' });
      this.copyButtonClicked = true;
    };

    initShareButtons();
    this.trackShareButtons('user-novena-social');
  }

  unmount() {
    super.unmount();
  }
}
